import React from "react";
import "./tabs.scss";

export const Tabs = ({ value, onValueChange, children, className }) => {
  const [active, setActive] = React.useState(value);

  const handleChange = (v) => {
    setActive(v);
    if (typeof onValueChange === "function") {
      onValueChange(v);
    }
  };

  // Render children, injecting active state and change handler where needed
  const enhancedChildren = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) return child;

    if (child.type.displayName === "TabsList") {
      return React.cloneElement(child, {
        active,
        onChange: handleChange,
      });
    }

    if (child.type.displayName === "TabsContent") {
      return React.cloneElement(child, { active });
    }

    return child;
  });

  return (
    <div className={`tabs ${className || ""}`} data-active={active}>
      {enhancedChildren}
    </div>
  );
};

export const TabsList = ({ children, active, onChange = () => {} }) => (
  <div className="tabs-list">
    {React.Children.map(children, (child) =>
      React.isValidElement(child)
        ? React.cloneElement(child, {
            active: child.props.value === active,
            onClick: () => onChange(child.props.value),
          })
        : child
    )}
  </div>
);

TabsList.displayName = "TabsList";

export const TabsTrigger = ({ value, active, onClick, children }) => (
  <button
    type="button"
    className={`tabs-trigger ${active ? "active" : ""}`}
    onClick={onClick}
  >
    {children}
  </button>
);
TabsTrigger.displayName = "TabsTrigger";

export const TabsContent = ({ value, active, children }) => {
  if (value !== active) return null;
  return <div className="tabs-content">{children}</div>;
};
TabsContent.displayName = "TabsContent";
